import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
//import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {DataGridModule, Header, Footer, SelectItem, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, CalendarModule, ConfirmationService} from 'primeng/primeng';
import { TeamMemberDirectoryService } from '../../Services/team-member-directory.service';
import {ProfileDataService}  from '../../Services/ProfileData';

//import

@Component({
    //moduleId: module.id,
    templateUrl: './team-member-directory.component.html',
    styleUrls: ['./team-member-directory.component.css']
})

export class TeamMemberDirectoryComponent implements OnInit {
    teamMemberDirectory : TeamMemberDirectory[];
    filteredTeamMemberDirectory : TeamMemberDirectory[];
    constructor(private router: Router,private teamMemberDirectoryService: TeamMemberDirectoryService ,private ProfileDataService: ProfileDataService) { }
    filter:string = '';

    orderByList = [
        { label: 'Contact', value: 'CON' },
        { label: 'Extension', value: 'EXT' },
        { label: 'Designation', value: 'DES' },
        { label: 'Delivery Unit', value: 'DEL' },
        { label: 'Location', value: 'BUS' },
        { label: 'Lead', value: 'LEA' },
        { label: 'Manager', value: 'MAN' },
        { label: 'Date Of Joining', value: 'DOJ' },
        { label: 'Address', value: 'ADD' },
        { label: 'Email', value: 'EMA' }
    ]

    orderByValue: string = 'DOJ';
    ngOnInit() {
      
         this.teamMemberDirectoryService.GetTeamMemberDirectory().subscribe((lstprofiles) => {
            this.teamMemberDirectory = lstprofiles;
            //console.log('this.teamMemberDirectory is: ', this.teamMemberDirectory);
            if(this.teamMemberDirectory != null && this.teamMemberDirectory.length > 0){
                this.teamMemberDirectory.forEach((item) => {
                    item.headerValue = item.firstName + ' ' + item.lastName + ' (' + item.teamMemberCode + ')'        
                    if(item.dateofJoining.length > 5){
                        item.dateofJoining = item.dateofJoining.split(' ')[0];
                    }
                    if(item.dateofJoining== '1/1/1900'){
                        item.dateofJoining = '';
                    }
                    if(item.dateofJoining){
                        item.doj = new Date(item.doj);
                    }

                    item.searchtext = item.firstName + ' ' + item.lastName;
                })
            }

            this.filteredTeamMemberDirectory = JSON.parse(JSON.stringify(this.teamMemberDirectory));           

             this.onOrderByChange(null);
        }
        );
    }

    onFilterChange(event){
        console.log('filter is: ', this.filter);
        var tempFilterValue = this.filter;
        this.filteredTeamMemberDirectory = this.teamMemberDirectory.filter(function(elem){
            return elem.firstName.toUpperCase().includes(tempFilterValue.toUpperCase()) 
                    || elem.lastName.toUpperCase().includes(tempFilterValue.toUpperCase())
                    || elem.email.toUpperCase().includes(tempFilterValue.toUpperCase())
                  
                    || elem.mobile.includes(tempFilterValue)
                    || elem.searchtext.toUpperCase().includes(tempFilterValue.toUpperCase());
                    
        }) 
        
        console.log("filtered teamMembers"  ,this.filteredTeamMemberDirectory)
        this.onOrderByChange(null);
        
    }

    onOrderByChange(event){
        var tempValue = this.orderByValue;
        console.log('tempValue: ', tempValue);
        if(tempValue == 'DOJ'){

            // this.filteredTeamMemberDirectory = this.filteredTeamMemberDirectory.sort(function(a, b) {
            //     return a.doj - b.doj;
            // });
        }
        else{
            this.filteredTeamMemberDirectory = this.filteredTeamMemberDirectory.sort( function(a, b) {
                var nameA = a.firstName.toUpperCase(); // ignore upper and lowercase
                var nameB = b.firstName.toUpperCase(); // ignore upper and lowercase
            
                if( tempValue == 'CON'){
                    nameA = a.mobile; 
                    nameB = b.mobile;
                }
                else if(tempValue == 'EXT'){
                    nameA = a.extension; 
                    nameB = b.extension;
                }
                else if(tempValue == 'DES'){
                }
                else if(tempValue == 'DEL'){
                    nameA = a.deliveryUnitName.toUpperCase(); 
                    nameB = b.deliveryUnitName.toUpperCase(); 
                }
                else if (tempValue == 'BUS') {
                    nameA = a.businessUnitName.toUpperCase();
                    nameB = b.businessUnitName.toUpperCase();
                }
                else if(tempValue == 'LEA'){
                    nameA = a.leadFirstName.toUpperCase(); 
                    nameB = b.leadFirstName.toUpperCase(); 
                }
                else if(tempValue == 'MAN'){
                    nameA = a.managerFirstName.toUpperCase(); 
                    nameB = b.managerFirstName.toUpperCase(); 
                }
                else if(tempValue == 'DOJ'){
                    //nameA = a.doj; 
                    //nameB = b.doj; 
                }
                else if(tempValue == 'ADD'){
                    nameA = a.permanentAddress.toUpperCase(); 
                    nameB = b.permanentAddress.toUpperCase(); 
                }
                else if(tempValue == 'EMA'){
                    nameA = a.email.toUpperCase(); 
                    nameB = b.email.toUpperCase(); 
                }
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                // names must be equal
                return 0;
            })
        }
            
    }

    // sort by value
    sortByValue (a, b) {
        return a.value - b.value;
    };

    // sort by name
    goToTeamHierarchy(userId: string) {
        this.router.navigate(['/teamhierarchy', userId]);
      }

    setDefaultImage(event: Event) {
        const target = event.target as HTMLImageElement;
        target.src = '/Images/no-image.png';
    }

    setAutoImagePosition(event: Event, manualImagePosition?: string) {
        if (manualImagePosition) {
            return;
        }

        const target = event.target as HTMLImageElement;
        if (!target || !target.naturalWidth || !target.naturalHeight) {
            return;
        }

        const aspectRatio = target.naturalWidth / target.naturalHeight;
        target.style.setProperty('object-position', aspectRatio < 0.6 ? 'center 25%' : 'center top');
    }
       
} 

export interface TeamMemberDirectory {
    id: number;
    userID;
    firstName;
    lastName;
    teamMemberCode;
    mobile;
    permanentAddress;
    deliveryUnitID;
    deliveryUnitName;
    businessUnitName;
    leadID;
    leadFirstName;
    leadLastName;
    leadTeamMemberCode;
    headerValue;
    email;
    maritalStatus;
    designation;
    imagePath;
    imagePosition;
    dateofJoining; 
    managerFirstName;
    managerLastName; 
    extension;
    doj;
    searchtext;
    workLocation;
    HRBusinessPartner;
}


// WEBPACK FOOTER //
// ./src/app/Components/team-member-directory/team-member-directory.component.ts